export class GoodlokAuthError extends Error {}

export class InvalidPasswordError extends GoodlokAuthError {}

export class UnknownEmailError extends GoodlokAuthError {}
